import { useSettings } from "@/context/SettingsContext";
import { useSeo } from "@/lib/useSeo";
import { PublicLayout } from "@/components/site/PublicLayout";

export default function Disclaimer() {
  const settings = useSettings();
  const c = settings?.contact || {};
  useSeo({ title: "Disclaimer | Adv. Guruvayoorappan K V", description: "Legal disclaimer for the website of Adv. Guruvayoorappan K V, Advocate, Thrissur.", robots: "index, follow" });
  return (
    <PublicLayout hideFooterCTA>
      <section className="bg-navy py-14"><div className="max-w-4xl mx-auto px-4 sm:px-6"><h1 className="font-serif text-4xl lg:text-5xl text-ivory">Disclaimer</h1></div></section>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14 prose-legal" data-testid="disclaimer-content">
        <p>The information provided on this website is intended for general informational purposes only. By accessing this website, the reader acknowledges and agrees to the following:</p>
        <ul>
          <li>The content of this website is for general informational purposes and does not automatically constitute legal advice.</li>
          <li>Reading the content of this website does not create an advocate–client relationship between the reader and Adv. Guruvayoorappan K V.</li>
          <li>Sending an online enquiry through this website does not automatically create an advocate–client relationship.</li>
          <li>Legal advice depends on the specific facts of each matter and the applicable law, and should be sought for your particular circumstances.</li>
          <li>Acceptance of any matter depends on the jurisdiction, the facts of the matter and professional availability.</li>
          <li>No outcome, result or success is guaranteed in any legal matter.</li>
        </ul>
        <p>For advice specific to your situation, please contact the office directly. Office: {c.address}. Phone: {c.phone1}, {c.phone2}.</p>
      </div>
    </PublicLayout>
  );
}
